import type { RootState } from '@core/Store'

export const selectPrevRacingSearchTerms = (state: RootState) => state.search.prevRacingSearchTerms
export const selectPrevSportsSearchTerms = (state: RootState) => state.search.prevSportsSearchTerms
